import { FormLabel, TextField } from "@material-ui/core";
import {
  StyledComponentProps,
  StyleRulesCallback,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import * as React from "react";
import { isEqual } from "lodash";

import ProgressOverlay from "./ProgressOverlay";

interface Props {
  isLoading?: boolean;
  label?: string;
  size?: "medium" | "small";
  onChange?: (value: Array<{ label: string; value: unknown }>) => void;
  options: Array<{ label: string; value: unknown }>;
  placeholder?: string;
  value?: Array<{ label: string; value: unknown }>;
  disabled?: boolean;
  id?: string;
}

class AutocompleteMultiple extends React.Component<
  Props & StyledComponentProps & { theme: Theme }
> {
  public render(): JSX.Element {
    const { classes } = this.props;
    return (
      <div id={this.props.id}>
        <ProgressOverlay loading={this.props.isLoading}>
          {this.props.label && (
            <FormLabel component="div">{this.props.label}</FormLabel>
          )}
          <Autocomplete
            disabled={this.props.disabled}
            multiple
            options={this.props.options}
            size={this.props.size}
            getOptionSelected={(test, compare) => isEqual(test, compare)}
            value={this.props.value}
            getOptionLabel={(option) => option.label}
            noOptionsText="Keine Optionen verfügbar"
            onChange={(event, value) =>
              this.props.onChange && this.props.onChange(value)
            }
            renderInput={(params) => (
              <TextField
                {...params}
                className={classes && classes.autocompleteText}
                placeholder={this.props.placeholder}
                margin="normal"
              />
            )}
          />
        </ProgressOverlay>
      </div>
    );
  }
}

const styles: StyleRulesCallback<Theme, Props> = (theme: Theme) => ({
  autocompleteText: {
    marginTop: theme.spacing(1),
  },
});

export default withStyles(styles, { withTheme: true })(AutocompleteMultiple);



// WEBPACK FOOTER //
// ./src/components/Autocomplete.tsx